import { createReducer, on } from '@ngrx/store';
import { UserActions, UserApiActions } from '../actions/user.actions';
import { UserStore } from '../models/user-store.model';

export const initialState: UserStore = {
    details: undefined
}

export const userReducer = createReducer(
    initialState,
    on(UserApiActions.retrieveUser, (_state,details) => ({
        ..._state,
        details: details
    })),
    on(UserActions.logoutUser, _state => ({
        details: undefined
    }))
)